import RightContent from '@/components/RightContent';
import { Fetch as GFetch } from '@shoppykey/center-sdk';
import { HooksService } from '@shoppykey/hook';
import { history } from '@umijs/max';
import { App, Button, Result } from 'antd';
import _ from 'lodash';
import { ReactNode } from 'react';
import { SWRConfig } from 'swr';
import { themeSettings } from '../config/themeSettings';
import { registerApps } from './Apps';
import Footer from './components/Footer';
import './global.less';
import type { CurrentUser, GlobalData } from './schema/GlobalData';
import { Fetch } from './utils/fetch';
import { log } from './utils/log';
const ignorePathList = ['/auth/login', '/auth/register'];

GFetch.client = Fetch;

async function fetchUserInfo() {
  const info = await Fetch.get<CurrentUser>(`/s/currentUser`);
  return info;
}

export async function getInitialState(): Promise<GlobalData> {
  const hooksService = new HooksService();
  // 如果是登录页面，不执行
  if (!_.includes(ignorePathList, history.location.pathname)) {
    try {
      const currentUser = await fetchUserInfo();
      registerApps(hooksService);
      return {
        currentUser,
        settings: themeSettings,
        hooksService,
      };
    } catch (error) {
      log.warn(error);
    }
  }
  return {
    settings: themeSettings,
    hooksService,
  };
}

export const layout = ({ initialState }: { initialState: { settings?: any; currentUser?: CurrentUser } }) => {
  return {
    rightContentRender: () => <RightContent />,
    disableContentMargin: false,
    footerRender: () => <Footer />,
    onPageChange: () => {
      // 如果没有登录，重定向到 login
      if (!initialState?.currentUser?.username && !_.includes(ignorePathList, history.location.pathname)) {
        log.warn('未登录重定向');
        history.push('/auth/login');
      }
    },
    logo: () => {
      return <img src="/logo.svg" alt="" />;
    },
    token: {
      pageContainer: {
        marginInlinePageContainerContent: 24,
      },
      sider: {
        colorMenuBackground: '#fff',
        colorMenuItemDivider: '#dfdfdf',
        colorTextMenu: '#595959',
      },
    },
    childrenRender(dom: ReactNode) {
      if (!initialState?.settings) {
        return (
          <Result
            status="500"
            title="500"
            subTitle="系统出错了"
            extra={
              <Button
                type="primary"
                onClick={() => {
                  location.reload();
                }}
              >
                重新加载
              </Button>
            }
          />
        );
      }
      return (
        <SWRConfig
          value={{
            refreshInterval: 0,
            revalidateOnFocus: false,
            revalidateOnMount: true,
            revalidateOnReconnect: false,
            refreshWhenOffline: false,
            refreshWhenHidden: false,
            fetcher: (resource, init) => Fetch.get(resource, init),
          }}
        >
          <App>{dom}</App>
        </SWRConfig>
      );
    },
    ...initialState?.settings,
  };
};
